import { render, staticRenderFns } from "./BulkOpsTable.vue?vue&type=template&id=20e48fca&"
import script from "./BulkOpsTable.vue?vue&type=script&lang=js&"
export * from "./BulkOpsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports